<template>
  <div class="regicall-short-schedule">

    <hr class="mt-1">
    <h4 v-if="active" class="has-text-weight-bold my-4">Je kan deze {{ period.label.toLowerCase() }} nog bellen met</h4>
    <h4 v-else class="has-text-weight-bold my-4">Je hebt niet gebeld naar</h4>
    <div v-if="planned">
      <short-schedule-row v-for="call in planned"
                          :call="call"
                          :key="call.id"
                          :active="active"
      >
        <div v-if="call.client && call.client.sticky" class="p-04rem has-text-weight-bold">
          {{ call.client.sticky }}
        </div>
      </short-schedule-row>
    </div>

    <!-- When all calls are completed or closed -->
    <h5 v-if="!planned">Gefeliciteerd je hebt iedereen gebeld!</h5>

    <h4 class="has-text-weight-bold my-4" v-if="completed.length > 0">Je hebt al gebeld naar</h4>
    <div v-if="completed">
      <short-schedule-row v-for="call in completed"
                          :call="call"
                          :key="call.id"
                          :completed="true">
      </short-schedule-row>
    </div>

    <!-- When no calls have been completed -->
    <h5 v-if="!completed">Je hebt nog geen afspraken afgesloten</h5>
  </div>
</template>

<script>
  import ShortScheduleRow from './ShortScheduleRow.vue';

  export default {
    components: { ShortScheduleRow },
    props: {
      calls: {
        type: Array,
        required: true,
      },
      period: {
        type: Object,
        required: true
      },
      active: {
        type: Boolean,
        default: true
      },
      date: {
        type: Object
      }
    },
    data () {
      return {};
    },
    computed: {
      sortedCalls () {
        return this.calls.sort((callA, callB) => {
          if (!callA.client || !callB.client) {
            return 0
          }
          if (callA.client.sticky.length === callB.client.sticky.length) {
            return 0
          }
          return callA.client.sticky.length > callB.client.sticky.length ? -1 : 1
        })
      },
      planned () {
        return this.sortedCalls.filter(call => {
          return !call.is_finished;
        });
      },
      completed () {
        return this.sortedCalls.filter(call => {
          return call.is_finished;
        });
      }
    }
  };
</script>
